import React from 'react';
import { observer } from "mobx-react";
import { File } from "./file";
import { Alert, Card, List, Tag, Typography, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

const { Text } = Typography;

@observer
export class UploadVariantAssets extends React.Component {
    findVariation = (id) => {
        let variation;

        this.props.item.variationsTypes.forEach(variationType => {
            if (typeof variation === 'undefined') {
                variation = variationType.variations.find(v => v.id === id);
            }
        });

        return variation;
    }

    name = () => this.props.variant.variationsIds
        .map((id) => {
            const variation = this.findVariation(id)
            if (typeof variation !== 'undefined') {
                return variation.title;
            }
        })
        .join(' ');

    beforeUpload = (file) => {
        this.props.addFiles(this.props.variant.id, [file]);
        return false;
    };

    render() {
        const { files, detectedFeatures } = this.props;
        const variantName = this.name();

        return (
            <Card
                title={<Text strong>{variantName || 'Default Variant'}</Text>}
                size="small"
            >
                <Upload.Dragger
                    multiple
                    showUploadList={false}
                    beforeUpload={this.beforeUpload}
                    style={{ marginBottom: files.length > 0 ? 16 : 0 }}
                >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Drop variant assets here or click to browse</p>
                    <p className="ant-upload-hint">.babylon, .glb, textures, and other model files</p>
                </Upload.Dragger>

                {files.length > 0 && (
                    <List
                        size="small"
                        dataSource={files}
                        renderItem={(file) => (
                            <List.Item key={file.uuid}>
                                <File {...this.props} file={file} />
                            </List.Item>
                        )}
                    />
                )}

                {detectedFeatures && (detectedFeatures.hasCabinetTexture || detectedFeatures.hasCabinetCountertop || detectedFeatures.hasDoorTexture || detectedFeatures.hasWindowTexture || detectedFeatures.hasBackground) && (
                    <Alert
                        type="info"
                        style={{ marginTop: 12 }}
                        message="Detected model features"
                        description={
                            <div>
                                {detectedFeatures.hasCabinetTexture && (
                                    <div><Tag color="blue">Cabinet texture</Tag> Door color can be customized</div>
                                )}
                                {detectedFeatures.hasCabinetCountertop && (
                                    <div style={{ marginTop: 4 }}><Tag color="blue">Countertop texture</Tag> Countertop material can be customized</div>
                                )}
                                {detectedFeatures.hasDoorTexture && (
                                    <div style={{ marginTop: 4 }}><Tag color="blue">Door texture</Tag> Door color can be customized</div>
                                )}
                                {detectedFeatures.hasWindowTexture && (
                                    <div style={{ marginTop: 4 }}><Tag color="blue">Window texture</Tag> Window color can be customized</div>
                                )}
                                {detectedFeatures.hasBackground && (
                                    <div style={{ marginTop: 4 }}><Tag color="blue">Background</Tag> See-through background will be painted with the scene color</div>
                                )}
                            </div>
                        }
                        showIcon
                    />
                )}
            </Card>
        );
    }
}
